import {createUseStyles} from 'react-jss'
import {CompanyReportRepresentativeModel} from '../../redux/companyMonitorTypes';
import Badge from "react-bootstrap/Badge";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";
import ReportModal from "./ReportModal";
import {formatDateString, getAgeFromBirthDate} from "../../utils/dateHelper";
import ComplianceBadge from "./ComplianceBadge";
import CompanyReportInfoCard from "./CompanyReportInfoCard";
import CountryFlag from "../CountryFlag";

interface Props {
  representative: CompanyReportRepresentativeModel,
}

const CompanyReportRepresentativeCard = ({representative}: Props) => {
  const styles = useStyles()
  const [representativeAmlReportModalVisible, setRepresentativeAmlReportModalVisible] = useState(false)

  const isFlagged = representative.isSanction || representative.isPep || representative.isRca

  const name = `${representative.givenName} ${representative.familyName}`
  const title = representative.dateOfBirth
    ? `${name}, ${getAgeFromBirthDate(representative.dateOfBirth)}`
    : name

  const renderPositionBadge = (position: string) => (
    <Badge key={position} bg={"info"}>{position}</Badge>
  )

  return (
    <>
      <CompanyReportInfoCard
        title={title}
        icon={faUser}
        flagged={isFlagged}
        onClick={() => setRepresentativeAmlReportModalVisible(true)}
        sources={representative.sources ?? []}>
        <p>Birth date: <span>{representative.dateOfBirth ? formatDateString(representative.dateOfBirth) : '-'}</span></p>
        <p>Country: <span style={{textTransform: "uppercase"}}>
          {representative.country
            ? <><CountryFlag country={representative.country}/>{' '}{representative.country}</>
            : '-'}
        </span></p>
        <p>Email: <span>{representative.email ?? '-'}</span></p>

        <div className={`${styles.badgeContainer} ${styles.positionBadgeContainer}`}>
          {representative.positions.map(renderPositionBadge)}
        </div>

        <div className={styles.badgeContainer}>
          <ComplianceBadge
            flagged={representative.isSanction}
            flaggedLabel='Sanctioned'
            compliantLabel='Not sanctioned'
          />
          <ComplianceBadge
            flagged={representative.isPep}
            flaggedLabel='PEP'
            compliantLabel='No PEP'
          />
          <ComplianceBadge
            flagged={representative.isRca}
            flaggedLabel='RCA'
            compliantLabel='No RCA'
          />
        </div>
      </CompanyReportInfoCard>

      <ReportModal
        title='Company representative AML report'
        visible={representativeAmlReportModalVisible}
        reportContent={representative.amlReport}
        onCloseClick={() => setRepresentativeAmlReportModalVisible(false)}
      />
    </>
  )
}
export default CompanyReportRepresentativeCard

const useStyles = createUseStyles({
  badgeContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    fontFamily: 'Aestetico-Regular',
    fontSize: "large"
  },
  positionBadgeContainer: {
    marginTop: 12,
    marginBottom: 8
  }
})
